import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './ContentBox.module.scss';

import { Container } from 'common/components/Layout/Layout';

class ContentBox extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  };

  render() {
    const { title, subtitle, text } = this.props;
    return (
      <div className={styles.ContentBox}>
        <Container>
          <p className={styles.Title}>{title}</p>
        </Container>
        <Container>
          <p className={styles.Description}>{subtitle}</p>
        </Container>
        <div
          className={styles.Text}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    );
  }
}

export default ContentBox;



// WEBPACK FOOTER //
// ./src/views/History/components/StoryBox/ContentBox/ContentBox.js